import { styled } from '@mui/material';

export const RapidSOSRoot = styled('div')(() => ({
  position: 'absolute',
  top: 0,
  right: 0,
  padding: '12px 20px',
}));
